export const VOLUME = [
  { key: 500000, value: 500000 },
  { key: 1000000, value: 1000000 },
  { key: 10000000, value: 10000000 },
  { key: 50000000, value: 50000000 },
];

export const PEOPLE = [
  { key: 1, value: '1-2' },
  { key: 2, value: '3-4' },
  { key: 3, value: '5-6' },
  { key: 4, value: '7-10' },
];
